export default __webpack_public_path__ + "static/media/registro-punto-control.0d56c9cd.png";